export const API = process.env.REACT_APP_API_URL || "https://web-production-3077c.up.railway.app/api";
export const cores = { alta: "#dc2626", media: "#d97706", baixa: "#16a34a" };
export const CORES_GRAFICO = ["#16a34a", "#d97706", "#dc2626", "#2563eb", "#9333ea", "#0891b2"];
export const MOTIVOS_PAUSA = ["Condições climáticas", "Aguardando insumo/produto", "Equipamento em manutenção", "Mudança de estratégia", "Falta de mão de obra", "Outro"];
export const MOTIVOS_ALTERACAO_PRAZO = ["Condições climáticas desfavoráveis", "Aguardando insumo/produto", "Replanejamento operacional", "Conflito com outra tarefa", "Solicitação do proprietário", "Outro"];
export const CULTURAS_TODAS = ["cafe", "soja", "milho", "pecuaria", "pimenta", "eucalipto", "seringueira", "cacau", "avicultura", "suino", "caprino", "ovino", "aipim", "mandioca", "batata", "sorgo", "girassol", "algodao", "cana", "citros", "laranja", "limao", "banana", "maracuja", "abacate", "manga", "mamao", "abacaxi", "coco", "dende", "urucum", "feijao", "arroz", "trigo", "amendoim", "gergelim", "sisal", "borracha", "teca", "mogno", "pinus", "acacia", "bambu", "outro"];
export const IA_SUGESTOES = ["Ex: Aplicar herbicida pré-emergente no Talhão 3 antes da chuva", "Ex: Planejar adubação de cobertura para o café na próxima semana", "Ex: Verificar sistema de irrigação do setor norte com urgência", "Ex: Coleta de solo para análise no Talhão 2 até sexta-feira"];

export const toInputDate = (str) => {
  if (!str || str === "A definir") return "";
  try { const [d, m, a] = str.split("/"); return `${a}-${m.padStart(2,"0")}-${d.padStart(2,"0")}`; } catch { return ""; }
};
export const fromInputDate = (str) => {
  if (!str) return "";
  try { const [a, m, d] = str.split("-"); return `${d}/${m}/${a}`; } catch { return ""; }
};

export const statusInfo = {
  nao_planejada: { label: "Não planejada", emoji: "🆕", bg: "bg-gray-100", text: "text-gray-600", border: "border-gray-200" },
  planejada: { label: "Planejada", emoji: "📋", bg: "bg-blue-50", text: "text-blue-700", border: "border-blue-200" },
  atrasada: { label: "Atrasada", emoji: "🔴", bg: "bg-red-50", text: "text-red-700", border: "border-red-200" },
  em_execucao: { label: "Em execução", emoji: "▶️", bg: "bg-blue-50", text: "text-blue-700", border: "border-blue-200" },
  pausada: { label: "Pausada", emoji: "⏸️", bg: "bg-red-50", text: "text-red-700", border: "border-red-200" },
  concluida: { label: "Concluída", emoji: "✅", bg: "bg-green-50", text: "text-green-700", border: "border-green-200" },
};

export const perfilLabel = { dono: "👑 Dono", adm: "🔧 ADM", gestor: "👨‍💼 Gestor", operador: "👷 Operador", consultor: "🌿 Consultor" };

export const COLUNAS_KANBAN = [
  { status: "nao_planejada", label: "Não planejada", emoji: "🆕", bg: "bg-gray-100", text: "text-gray-600", border: "border-gray-200" },
  { status: "planejada", label: "Planejada", emoji: "📋", bg: "bg-blue-50", text: "text-blue-700", border: "border-blue-200" },
  { status: "atrasada", label: "Atrasada", emoji: "🔴", bg: "bg-red-50", text: "text-red-700", border: "border-red-200" },
  { status: "em_execucao", label: "Em execução", emoji: "▶️", bg: "bg-blue-50", text: "text-blue-700", border: "border-blue-200" },
  { status: "pausada", label: "Pausada", emoji: "⏸️", bg: "bg-red-50", text: "text-red-700", border: "border-red-200" },
];

export const haptic = (pattern = [10]) => { try { navigator.vibrate && navigator.vibrate(pattern); } catch (e) {} };

export const isHoje = (prazo) => {
  if (!prazo || prazo === "A definir") return false;
  try {
    const [d, m, a] = prazo.split("/");
    const hoje = new Date();
    return parseInt(d) === hoje.getDate() && parseInt(m) === (hoje.getMonth() + 1) && parseInt(a) === hoje.getFullYear();
  } catch { return false; }
};
